export function initDialogs() {
    /** @type {NodeListOf<HTMLDialogElement>} */
    const dialogs = document.querySelectorAll('.dialog');
    for (const dialog of dialogs) {
        /** @type {HTMLButtonElement} */
        const close = dialog.querySelector('.dialog-close');

        close.addEventListener('click', () => {
            dialog.close();
        });
    }
}